<template>
  <MainLayout>
    <div 
      :class="theme === 'dark' ? 'tw-bg-[#151515] tw-text-gray-100' : 'tw-bg-gray-100 tw-text-gray-800'" 
      class="tw-min-h-screen tw-p-4 md:tw-p-8"
      :data-theme="theme"
    >
      <div class="tw-mb-6 md:tw-mb-8">
        <h1 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-xl md:tw-text-2xl tw-font-bold">
          Relatório de Termometria - {{ unidade.nome || 'Unidade' }}
        </h1>
      </div>

      <div class="tw-grid tw-grid-cols-1 tw-gap-6 md:tw-gap-8">
        <div 
          :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-gray-800' : 'tw-bg-white tw-border-gray-100'" 
          class="tw-rounded-2xl tw-p-5 md:tw-p-8 tw-shadow-2xl tw-border"
        >
          <div class="tw-flex tw-items-center tw-gap-4 tw-mb-6 md:tw-mb-8">
            <div :class="theme === 'dark' ? 'tw-bg-blue-500/10' : 'tw-bg-blue-50'" class="tw-p-3 tw-rounded-xl">
              <i class="fa-solid fa-filter tw-text-blue-500 tw-text-lg"></i>
            </div>
            <h2 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-base md:tw-text-lg tw-font-bold m-0">Filtros de Busca</h2>
          </div>

          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4 md:tw-gap-6">
            <div class="tw-space-y-2">
              <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Local</label>
              <select v-model="selectedSilo" class="tw-custom-input tw-border-none">
                <option :value="null">Selecione o silo...</option>
                <option v-for="silo in silosFiltered" :key="silo.id" :value="silo.id">{{ silo.nome }}</option>
              </select>
            </div>
            <div class="tw-space-y-2">
              <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Data Início</label>
              <input type="date" v-model="dataInicio" class="tw-custom-input tw-border-none" />
            </div>
            <div class="tw-space-y-2">
              <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Data Final</label>
              <input type="date" v-model="dataFinal" class="tw-custom-input tw-border-none" />
            </div>
            <div class="tw-flex tw-items-end">
              <button 
                @click="fetchLeiturasBySilo" 
                :disabled="buscandoLeituras"
                class="tw-w-full tw-py-3 md:tw-py-4 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-text-xs tw-font-bold tw-uppercase hover:tw-bg-blue-700 tw-shadow-lg tw-shadow-blue-600/20 tw-border-none disabled:tw-opacity-50"
              >
                {{ buscandoLeituras ? 'Buscando...' : 'Buscar Leituras' }}
              </button>
            </div>
          </div>

          <div>
            <div v-if="leiturasEncontradas.length > 0" class="tw-mt-8 tw-pt-8 tw-border-t tw-border-gray-800/10">
              <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6 tw-items-end">
                <div class="tw-space-y-2">
                  <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Horário da Leitura</label>
                  <select v-model="selectedLeitura" class="tw-custom-input tw-border-none">
                    <option v-for="leitura in leiturasEncontradas" :key="leitura._id" :value="leitura._id">{{ leitura.data }}</option>
                  </select>
                </div>
                <div class="tw-flex tw-items-center tw-gap-3 tw-pb-4">
                   <div class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                      <input type="checkbox" v-model="mostrarLeituraColorida" id="colorido" class="tw-sr-only tw-peer" />
                      <div class="tw-w-11 tw-h-6 tw-bg-gray-700 tw-rounded-full peer peer-checked:after:tw-translate-x-full after:tw-content-[''] after:tw-absolute after:tw-top-0.5 after:tw-left-[2px] after:tw-bg-white after:tw-rounded-full after:tw-h-5 after:tw-w-5 after peer-checked:tw-bg-green-600"></div>
                      <label for="colorido" class="tw-ml-3 tw-text-xs tw-font-bold tw-opacity-70">Ativar Mapa de Calor</label>
                   </div>
                </div>
                <div class="tw-flex tw-gap-3">
                  <button 
                    @click="gerarRelatorio" 
                    :disabled="loadingDados"
                    class="tw-flex-1 tw-py-3 tw-rounded-xl tw-bg-green-600 tw-text-white tw-text-sm tw-font-bold hover:tw-bg-green-700 tw-shadow-lg tw-shadow-green-600/20 tw-border-none"
                  >
                    Visualizar Termometria
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div 
          v-if="leituraData && leituraData.dados" 
          :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-border-gray-800' : 'tw-bg-white tw-border-gray-100'" 
          class="tw-rounded-2xl tw-shadow-2xl tw-border tw-overflow-hidden tw-relative tw-min-h-[400px]"
        >
          <div>
            <div v-if="loadingDados" class="tw-absolute tw-inset-0 tw-z-20 tw-bg-inherit tw-flex tw-flex-col tw-items-center tw-justify-center">
                <svg class="tw-animate-spin tw-h-10 tw-w-10 tw-text-green-500" fill="none" viewBox="0 0 24 24"><circle class="tw-opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="tw-opacity-100" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                <span class="tw-mt-4 tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-widest tw-opacity-50">Sincronizando Sensores...</span>
            </div>
          </div>

          <div class="tw-p-6 md:tw-p-8 tw-border-b tw-border-gray-800/10 tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-gap-6">
            <div>
              <h3 class="tw-text-2xl tw-font-black tw-uppercase tw-tracking-tight tw-m-0">{{ selectedSiloNome }}</h3>
              <p class="tw-text-xs tw-font-bold tw-opacity-40 tw-mt-1">{{ leituraData.data }} • {{ leituraData.produto }}</p>
            </div>
            
            <div class="tw-grid tw-grid-cols-2 tw-gap-4">
              <div class="tw-bg-black/5 tw-px-6 tw-py-3 tw-rounded-xl tw-text-center">
                <span class="tw-block tw-text-[9px] tw-font-black tw-opacity-40 tw-uppercase">Média Massa</span>
                <span class="tw-text-lg tw-font-black tw-text-green-500">{{ leituraData?.maxmedmin.med }}°C</span>
              </div>
              <div class="tw-bg-black/5 tw-px-6 tw-py-3 tw-rounded-xl tw-text-center">
                <span class="tw-block tw-text-[9px] tw-font-black tw-opacity-40 tw-uppercase">Nível</span>
                <span class="tw-text-lg tw-font-black tw-text-blue-500">
                  {{ siloSelecionado?.tipo_nivel == 1 ? siloSelecionado.nivel_automatico : siloSelecionado.nivel_manual }}%
                </span>
              </div>
            </div>
          </div>

          <div v-if="leituraData.estacao" class="tw-px-8 tw-py-4 tw-border-b tw-border-gray-800/5 tw-flex tw-flex-wrap tw-gap-10 tw-bg-black/[0.02]">
             <div class="tw-flex tw-items-center tw-gap-3">
                <div class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-bg-orange-500/10 tw-rounded-xl">
                    <i class="fa-solid fa-temperature-high tw-text-orange-500 tw-text-sm"></i>
                </div>
                <div>
                    <span class="tw-block tw-text-[9px] tw-font-black tw-opacity-40 tw-uppercase">Ambiente</span>
                    <span class="tw-text-xs tw-font-black">{{ leituraData.estacao.temperatura }}°C</span>
                </div>
             </div>
             <div class="tw-flex tw-items-center tw-gap-3">
                <div class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-bg-blue-500/10 tw-rounded-xl">
                    <i class="fa-solid fa-droplet tw-text-blue-500 tw-text-sm"></i>
                </div>
                <div>
                    <span class="tw-block tw-text-[9px] tw-font-black tw-opacity-40 tw-uppercase">Umidade Rel.</span>
                    <span class="tw-text-xs tw-font-black">{{ leituraData.estacao.umidade }}%</span>
                </div>
             </div>
             <div class="tw-flex tw-items-center tw-gap-3">
                <div :class="leituraData.estacao.chuva ? 'tw-bg-cyan-500/10' : 'tw-bg-yellow-500/10'" class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-xl">
                    <i :class="leituraData.estacao.chuva ? 'fa-solid fa-cloud-showers-heavy tw-text-cyan-500' : 'fa-solid fa-sun tw-text-yellow-500'" class="tw-text-sm"></i>
                </div>
                <div>
                    <span class="tw-block tw-text-[9px] tw-font-black tw-opacity-40 tw-uppercase">Clima</span>
                    <span class="tw-text-xs tw-font-black">{{ leituraData.estacao.chuva ? 'CHUVENDO' : 'SEM CHUVA' }}</span>
                </div>
             </div>
          </div>

          <div class="tw-overflow-x-auto">
            <table class="tw-w-full tw-text-center tw-border-none">
              <thead>
                <tr :class="theme === 'dark' ? 'tw-bg-black/40' : 'tw-bg-gray-100/80'">
                  <th class="tw-px-4 tw-py-4 tw-text-[10px] tw-font-black tw-uppercase tw-tracking-widest tw-border-r tw-border-gray-800/10 tw-w-20 tw-sticky tw-bg-inherit">CABO</th>
                  <th v-for="i in 16" :key="i" class="tw-px-1 tw-py-4 tw-text-[10px] tw-font-black tw-opacity-40">S{{i}}</th>
                </tr>
              </thead>
              <tbody class="tw-divide-y tw-divide-gray-800/5">
                <tr v-for="cabo in leituraData.dados" :key="cabo.cabo" class="hover:tw-bg-black/5">
                  <td class="tw-px-4 tw-py-4 tw-text-[11px] tw-font-black tw-bg-black/10 tw-border-r tw-border-gray-800/10 tw-sticky">{{ cabo.cabo }}</td>
                  <td 
                    v-for="index in 16" :key="index"
                    :style="mostrarLeituraColorida && isValido(cabo.temperaturas[`s${index}`]) ? { backgroundColor: getCorPorTemperatura(cabo.temperaturas[`s${index}`]) } : {}"
                    :class="[
                       'tw-px-1 tw-py-4 tw-text-sm tw-font-mono tw-font-black',
                       !isValido(cabo.temperaturas[`s${index}`]) ? 'tw-opacity-0' : (theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-900')
                    ]"
                  >
                    {{ isValido(cabo.temperaturas[`s${index}`]) ? parseFloat(cabo.temperaturas[`s${index}`]).toFixed(1) : '' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="!leituraData && !loadingDados" class="tw-py-20 tw-text-center tw-opacity-30">
            <p class="tw-text-xs tw-font-black tw-uppercase tw-tracking-widest">Selecione o silo e o período para visualizar a matriz</p>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
/* eslint-disable */
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import { useToast } from "vue-toastification";
import LoadingRelatorio from "@/components/ui/App/LoadingRelatorio.vue";
import temperaturaCores from "@/assets/colors.json";

export default {
    name: 'RelatorioTermometria',
    components: { MainLayout, LoadingRelatorio },

    setup() {
        const store = useStore();
        const toast = useToast();
        const leituraData = ref(null);
        const today = new Date().toISOString().split("T")[0];
        const dataInicio = ref(today);
        const dataFinal = ref(today);
        const loadingDados = ref(false);
        const buscandoLeituras = ref(false);
        const selectedSilo = ref(null);
        const selectedSiloNome = ref(null);
        const leiturasEncontradas = ref([]);
        const selectedLeitura = ref(null);
        const siloSelecionado = ref(null);
        const mostrarLeituraColorida = ref(true);

        const theme = computed(() => store.state.ui.theme);
        const unidade = computed(() => store.state.unidade.unidade || {});
        const silosFiltered = computed(() => {
          if (!unidade.value?.id) return store.state.silos.silos || [];
          return (store.state.silos.silos || []).filter(s => String(s.unidade_id) === String(unidade.value.id));
        });

        const isValido = (temp) => {
            if (temp === undefined || temp === null || isNaN(temp) || Number(temp) > 99) return false;
            return true;
        };

        const fetchLeiturasBySilo = async () => {
            if (!selectedSilo.value) return toast.warning('Selecione um silo.');
            try {
                buscandoLeituras.value = true;
                leiturasEncontradas.value = [];
                const d_inicio = new Date(dataInicio.value + 'T00:00:00');
                const d_final = new Date(dataFinal.value + 'T23:59:59');
                const siloObj = silosFiltered.value.find(s => s.id === selectedSilo.value);
                selectedSiloNome.value = siloObj?.nome;

                const data = await store.dispatch("leituras/fetchLeiturasBySilo", selectedSilo.value);
                leiturasEncontradas.value = data.filter(leitura => {
                    const dataSplit = leitura.data.split(' ')[0].split('/');
                    const leituraDate = new Date(`${dataSplit[2]}-${dataSplit[1]}-${dataSplit[0]}T00:00:00`);
                    return leituraDate >= d_inicio && leituraDate <= d_final;
                });

                if (leiturasEncontradas.value.length > 0) {
                    selectedLeitura.value = leiturasEncontradas.value[0]._id;
                } else {
                    toast.info('Nenhuma leitura encontrada.');
                }
            } catch (e) { toast.error('Erro ao buscar lista'); }
            finally { buscandoLeituras.value = false; }
        };

        const gerarRelatorio = async () => {
            if (!selectedLeitura.value) return;
            try {
                siloSelecionado.value = silosFiltered.value.find(s => s.id === selectedSilo.value);
                loadingDados.value = true;
                leituraData.value = null; 
                const response = await store.dispatch("leituras/fetchLeituraById", {
                  "siloId": selectedSilo.value,
                  "leituraId": selectedLeitura.value
                });
                leituraData.value = response;
              } catch (error) { toast.error('Erro ao carregar matriz'); }
            finally { setTimeout(() => { loadingDados.value = false; }, 300); }
        };

        const getCorPorTemperatura = (temp) => {
            if (!isValido(temp)) return 'transparent';
            const val = Number(temp);
            const faixas = Object.keys(temperaturaCores).map(Number).sort((a, b) => a - b);            
            for (let i = 0; i < faixas.length; i++) {
                // Adicionamos 'CC' no final do HEX para dar 80% de transparência e suavizar o fundo
                if (val <= faixas[i]) return `${temperaturaCores[faixas[i]]}CC`;
            }
            return "#c31313CC";
        };

        return {
            theme, unidade, silosFiltered, dataInicio, dataFinal, selectedSilo,
            loadingDados, selectedSiloNome, gerarRelatorio,
            leiturasEncontradas, selectedLeitura, fetchLeiturasBySilo,
            leituraData, siloSelecionado, mostrarLeituraColorida,
            buscandoLeituras, getCorPorTemperatura, isValido
        };
    },
}
</script>

<style scoped>
.tw-custom-input { @apply tw-w-full tw-border-none tw-rounded-xl tw-p-3 md:tw-p-4 tw-text-sm tw-outline-none; }
[data-theme="dark"] .tw-custom-input { background-color: rgba(39, 43, 47, 0.45); color: #f3f4f6; }
[data-theme="light"] .tw-custom-input { background-color: #f3f4f6; color: #1f2937; }
.tw-custom-input:focus { @apply tw-ring-2 tw-ring-green-500/20; }

::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-thumb { background: #33b35a; border-radius: 10px; }
</style>